<ng-container *ngIf="!isB2B">
    <div class="card card-vertical h-100" [style.width.px]="home ? 440 : 'auto'"
        *ngIf="product.precio != 9 || product.precio >= 1000">
        <div class="card-body d-flex flex-column justify-content-between align-items-center">
            <div class="image-container" (click)="getProductUrl()">
                <img src="{{ product.imagen }}" class="images" loading="lazy" (error)="defaultImage($event)" />
            </div>

            <div class="info-container b2b-info mt-3">
                <div *ngIf="product.pesoVariable" class="tag-peso mt-2">Peso variable</div>
                <span class="product-name">{{ product.nombre }}</span>
                <!-- Etiqueta -->
                <span class="paquete-label" *ngIf="!product.pesoVariable">
                  Paquete por {{product.pesoGramos}}gr
                </span>
                <span class="paquete-label" *ngIf="product.pesoVariable">
                  Paquete por {{ weightRangeInKg }} | {{ weightRangeInPounds }}
                </span>
                <span class="product-price">
                    <ng-container *ngIf="product.pesoVariable; else fixedPrice">
                        {{ pricePerPound(product.precio, product.pesoGramosVariable, product.pesoGramos) |
                        customCurrency }} Libra
                    </ng-container>
                    <ng-template #fixedPrice>
                        {{ product.precio | customCurrency }}
                    </ng-template>
                </span>
                <p class="product-weight" *ngIf="!product.pesoVariable">
                    {{ product.pesoGramos }}gr - ${{ formattedPesoGramos }}
                </p>
                <p class="product-weight" *ngIf="product.pesoVariable">
                    {{ product.pesoGramosVariable }}gr - ${{ formattedPesoGramos }}
                </p>
            </div>
            <div class="row-btn-quantity w-100 mt-3" *ngIf="product.cobertura && spSelected">
                <div *ngIf="product.add" class="col-quantity black-button">
                  <div class="group-icons" style="gap: 8px;">
                    <button class="remove" (click)="removeProduct()">
                      <img class="delete-icon" *ngIf="product.quantity === 1" src="../../../../assets/icons/shopping-cart/delete_icon.svg"
                                        alt="delete-icon" />
                      <img class="remove-icon" *ngIf="product.quantity > 1" src="../../../../assets/icons/shopping-cart/remove_circle.svg"
                                        alt="remove-circle" />
                    </button>
                    <span class="quantity">
                      {{ product.quantity}}
                    </span>
                    <button class="add" (click)="moreOneProduct()">
                      <img class="add-icon" src="../../../../assets/icons/shopping-cart/add_circle.svg"
                                        alt="add-circle" />
                    </button>
                  </div>
                </div>
                <button *ngIf="product.quantity === 0" (click)="addProduct()" class="btn card-button black-button">
                    Agregar <img class="cart-shopping" src="../../../../assets/icons/shopping-cart/shopping_cart.svg"
                                        alt="cart-shopping" />
                    <!-- <i class="fas fa-shopping-cart ms-2"></i> -->
                </button>
            </div>

            <ng-container *ngIf="!checkCobertura && !product.cobertura">
                <div class="row-btn-quantity">
                    <button class="btn card-button black-button" (click)="getProductUrl()">
                        Agregar <img class="cart-shopping" src="../../../../assets/icons/shopping-cart/shopping_cart.svg"
                                        alt="cart-shopping" />
                        <!-- <i class="fas fa-shopping-cart ms-2"></i> -->
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<!-- Card para productos de clientes B2B -->
<ng-container *ngIf="isB2B">
    <div class="card h-100" [style.width.px]="home ? 440 : 'auto'"
        *ngIf="product.precio != 9 || product.precio >= 1000">
        <div class="card-body">
            <div class="row m-0 h-100">
                <div class="col-5 image-container">
                    <div style="cursor: pointer;" (click)="getProductUrl()">
                        <img src="{{ product.imagen }}" class="images" loading="lazy" />
                        <div class="variable-weight-tag" *ngIf="product.pesoVariable">Peso variable</div>
                    </div>
                </div>
                <div class="col-7 d-flex flex-column justify-content-between">
                    <div style="cursor: pointer;" (click)="getProductUrl()">
                        <div class="info-container b2b-info">
                            <span class="b2b-price">
                                {{ product.precio | customCurrency }} / {{ product.unidadAbreviada }}
                            </span>
                            <span class="b2b-label" *ngIf="product.pesoVariable">
                                {{ product.pesoGramosVariable }}g - ($ {{ costForGram | number }}/g)
                            </span>
                            <span class="b2b-label" *ngIf="!product.pesoVariable">
                                {{ product.pesoGramos }}g - ($ {{ costForGram | number }}/g)
                            </span>
                            <span class="b2b-name">
                                {{ product.nombre }}
                            </span>
                            <span class="b2b-label" style="font-size: 16px;" *ngIf="product.pesoVariable && spSelected">
                                Desde {{ product.pesoGramosVariable }}g
                            </span>
                        </div>
                    </div>
                    <div class="row-btn-quantity" style="gap: 8px;" *ngIf="product.cobertura && spSelected">
                        <div *ngIf="product.add" class="d-flex">
                            <button class="add-b2b" (click)="removeQuantityProduct()">
                                <img src="../../../../assets/icons/shopping-cart/delete.svg" alt="trash can icon">
                            </button>
                        </div>
                        <input type="number" min="0" max="999" class="cantidad-b2b" [(ngModel)]="quantityProduct"
                            placeholder="Cantidad" [value]="(product.quantity > 0) ? product.quantity : ''"
                            (ngModelChange)="changeQuantityProduct()" maxlength="3" (input)="validateInput($event)">
                        <button *ngIf="product.quantity === 0 || !checkProductIcon" (click)="addQuantityProduct()"
                            type="button" class="btn add-b2b">
                            <img src="../../../../assets/imgs/Img-our-products/add_product.svg" alt="add product icon">
                        </button>
                        <button *ngIf="product.quantity > 0 && checkProductIcon" type="button" class="btn add-b2b">
                            <img src="../../../../assets/icons/shopping-cart/check-product.svg"
                                alt="check product icon">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
